import React from 'react';
import styled from 'styled-components';

import TriangleIcon from 'images/triangle.svg';

const SortableTableHeading = styled.th`
	cursor: pointer;

	&:hover {
		background: #f9f9f9;
	}

	img {
		display: ${props => (props.ordered ? 'inline-block' : 'none')};
		transform: rotate(${props => (props.order === 'asc' ? '0' : '180deg')});
		transition: transform 0.2s ease-out;
	}
`;

export default ({ children, ...rest }) => (
	<SortableTableHeading {...rest}>
		{children}
		<img src={TriangleIcon} alt="sort" width="12" className="ml10" />
	</SortableTableHeading>
);



// WEBPACK FOOTER //
// ./src/components/Common/Table/SortableTableHeading.js